// extracted by mini-css-extract-plugin
export var address = "SectionContactDetails-module--address--47e21";
export var buttoncontainer = "SectionContactDetails-module--buttoncontainer--3da98";
export var detail = "SectionContactDetails-module--detail--8309c";
export var detailsection = "SectionContactDetails-module--detailsection--5a2dc";
export var detailstitle = "SectionContactDetails-module--detailstitle--c393b";
export var detailswrapper = "SectionContactDetails-module--detailswrapper--203f8";
export var heading = "SectionContactDetails-module--heading--260b9";
export var icon = "SectionContactDetails-module--icon--7ef2b";
export var innerwrapper = "SectionContactDetails-module--innerwrapper--70d4e";
export var link = "SectionContactDetails-module--link--e8b0e";
export var openingtimes = "SectionContactDetails-module--openingtimes--4145c";
export var title = "SectionContactDetails-module--title--624f0 headings-module--sectionHeading--a8f67";